// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1w4W_","insightsList":"newBusinessInsightsMenu_insightsList__2pLGo","active":"newBusinessInsightsMenu_active__1YPrO"};